import { compileAjvSchema, throwAjvError } from './ajv.esm.js';

function entityKindSchemaValidator(schema) {
  const validate = compileAjvSchema(schema);
  return (data) => {
    const result = validate(data);
    if (result === true) {
      return data;
    }
    const softCandidates = validate.errors?.filter(
      (e) => ["/kind", "/apiVersion"].includes(e.instancePath)
    );
    if (softCandidates?.length && softCandidates.every((e) => e.keyword === "enum")) {
      return false;
    }
    throw throwAjvError(validate.errors);
  };
}

export { entityKindSchemaValidator };
//# sourceMappingURL=entityKindSchemaValidator.esm.js.map
